export type GUID = string
export const EmptyId = '00000000-0000-0000-0000-000000000000'

export enum DataResponseStatusGroup {
  General = 0,
  Player = 1,
  OrganizationPlayerRequest = 2,
  Organization = 3,
}

export enum DataResponseStatusIds {
  General_OK = 0,
  General_TimedOut = 1,
  General_AlreadyExist = 2,
  General_Error = 3,
  General_AccessDenied = 4,
  General_Expired = 5,
  General_NotFound = 6,
  General_Skipped = 7,

  Player_UsernameAlreadyExists = 100,
  Player_EmailAlreadyExists = 101,
  Player_FullnameIsMissing = 102,
  Player_UsernameIsMissing = 103,
  Player_PasswordIsMissing = 104,
  Player_EmailIsMissing = 105,
  Player_EmailIsInvalid = 106,
  Player_PasswordIsNotChanged = 107,

  OrganizationPlayerRequest_WaitingForResponse = 200,

  Organization_MissingName = 300,

  OrganizationPlayer_UnableToRemoveLastAdmin = 400,
  OrganizationPlayer_UnableToDisableLastActive = 401,

  OrganizationDepartment_RelationToActiveDepartmentRelationExists = 501,
  OrganizationDepartment_RelationToNotVerifiedDepartmentRelationExists = 502,
  OrganizationDepartment_RelationToVerifiedDepartmentRelationExists = 503,

  OrganizationDepartmentRelationVerified_UnableToOverlapOtherVerifiedWithSameDepartment = 601,

  OrganizationDepartmentRelationNotVerified_UnableToOverlapOtherNotVerifiedWithSameDepartment = 701,
  OrganizationDepartmentRelationNotVerified_UnableToOverlapOtherVerifiedWithSameDepartment = 702,

  ApproveOrganizationPlayerRequest_UnableToLocateOrgPlayer = 801,

  OrganizationActivityPlayerRelationRequest_WaitingForResponse = 900,
  OrganizationActivityPlayerRelationRequest_UnableToRemoveLastActivity = 901,

  MatchInProgress_TeamsAreInvalid = 1001,
  MatchInProgress_TeamPlayersAreInvalid = 1002,
  MatchInProgress_ScoresAreInvalid = 1003,

  Event_NameIsMissing = 1101,

  EventAttendee_EventIsMissing = 1201,

  EventCourt_EventStatusIsInvalid = 1301,

  Editor_FolderHasItems = 1902,
}

export interface IDataResponseStatus {
  Group: DataResponseStatusGroup
  Id: DataResponseStatusIds
  Name: string
  Message: string //atm only for ErrorWithMessage (General_Error)
}

export interface IDataResponse {
  Status: IDataResponseStatus //Most weight
  Statuses: IDataResponseStatus[] //All of them
  StatusName: string
  Id: GUID
  Message: string
  Data: any | undefined
}

export type AppType = 'rankytank' | 'hushold' | 'itimertoo' | 'tekstur' | 'editor'
export const mapAppTypeToServerAppType = (appType: AppType) => {
  switch (appType) {
    case 'hushold':
      return 1
    case 'itimertoo':
      return 2
    case 'tekstur':
      return 3
    case 'editor':
      return 4
    case 'rankytank':
    default:
      return 0
  }
}
